import {APP_STORE_URL} from '../constants/app';
import {GeoHubRestaurant} from './geoHubData';
import {getGeoCityContent} from './geoContent.mock';
import {GEO_CITY_PLACES_SNAPSHOTS} from './geo/places';
import {GeoCityPlaceFromApi, GeoCityPlacesSnapshot} from '../types/geoApi';

function buildStaticByPath(restaurantsDataKey: string): Map<string, GeoHubRestaurant> {
    const map = new Map<string, GeoHubRestaurant>();
    const content = getGeoCityContent(restaurantsDataKey);
    for (const row of content?.restaurants ?? []) {
        if (row.soltPath) {
            map.set(row.soltPath, {
                ...row,
                fullDescription: row.description,
                cardLink: {kind: 'app', href: APP_STORE_URL},
            });
        }
    }
    return map;
}

export function mapPlaceToHubRestaurant(
    place: GeoCityPlaceFromApi,
    staticByPath: Map<string, GeoHubRestaurant>,
): GeoHubRestaurant {
    const path = place.solt_link ?? undefined;
    const staticRow = path ? staticByPath.get(path) : undefined;
    const eats = place.posts_count ?? 0;

    return {
        name: place.place_name,
        cuisine: staticRow?.cuisine ?? 'Restaurant',
        neighborhood: staticRow?.neighborhood,
        description: '',
        soltPath: path,
        cardLink: {kind: 'app', href: APP_STORE_URL},
        dishImage: place.cover_image || undefined,
        priceRange: staticRow?.priceRange,
        formattedAddress: place.formatted_address?.trim() || undefined,
        starRating: place.rating ?? staticRow?.starRating,
        fullDescription: `${place.place_name} — ${eats} ${eats === 1 ? 'eat' : 'eats'} on Solt`,
        postsCount: eats,
    };
}

export function getGeoCityPlacesSnapshot(restaurantsDataKey: string): GeoCityPlacesSnapshot | undefined {
    return GEO_CITY_PLACES_SNAPSHOTS[restaurantsDataKey];
}

export function getHubRestaurantsFromSnapshot(
    restaurantsDataKey: string,
): GeoHubRestaurant[] | undefined {
    const snapshot = getGeoCityPlacesSnapshot(restaurantsDataKey);
    if (!snapshot?.places.length) {
        return undefined;
    }

    const staticByPath = buildStaticByPath(restaurantsDataKey);
    return [...snapshot.places]
        .map((place) => mapPlaceToHubRestaurant(place, staticByPath))
        .sort((a, b) => (b.postsCount ?? 0) - (a.postsCount ?? 0));
}
